"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[987],{

/***/ 2908:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Purple Booth Mark.555a1209.svg","height":620,"width":820});

/***/ }),

/***/ 77987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _public_Purple_Booth_Mark_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2908);




var MobileNav = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
        className: "bg-slate-100 dark:bg-slate-900 lg:hidden",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "m-4 flex inline-flex aspect-square content-center items-center justify-center rounded-full bg-slate-100 p-1",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                passHref: true,
                href: "/",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    "data-testid": "MobileNav",
                    className: "flex inline-flex",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        width: 49,
                        height: 49,
                        layout: "intrinsic",
                        src: _public_Purple_Booth_Mark_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
                        alt: "Purple Booth Ltd.",
                        unoptimized: true
                    })
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (MobileNav);


/***/ })

}]);